import React, { useState, useEffect } from "react";
import MenuArrowIcon from "../../../assets/svgs/menu-arrow-next.svg";
import cx from "classnames";

const HowToBuyStocks = ({ content, stepContents }) => {
  const [step, setStep] = useState(1);

  useEffect(() => {
    const timer = setTimeout(() => {
      const nextStep = step < 3 ? step + 1 : 1;
      setStep(nextStep);
    }, 3000);

    return () => clearTimeout(timer);
  }, [step]);

  return (
    <div className="zipstocks how-to-buy-stocks">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col">
            <h2 className="text-center">
              {content.nodes[0].acfPartials.pHeading}
            </h2>

            <div
              className="main-content description text-center"
              dangerouslySetInnerHTML={{
                __html: content.nodes[0].acfPartials.pContent,
              }}
            />
          </div>
        </div>

        <div className="row step justify-content-center">
          {stepContents.nodes.map((_stepContent, i) => (
            <>
              <div
                className={cx(
                  "col-12 col-md-6 col-xl-4 text-center mb-5 mb-md-0 d-none",
                  { "d-block": i + 1 === step }
                )}
              >
                <img
                  src={
                    stepContents.nodes[step - 1].acfPartials.pIcon.localFile
                      .publicURL
                  }
                  alt={stepContents.nodes[step - 1].acfPartials.pHeading}
                  className={cx("step__image img-fluid")}
                  width="360"
                />
              </div>
              <div
                className={cx(
                  "col-12 col-md-6 col-xl-4 d-none flex-column justify-content-between text-center text-md-left",
                  { "d-flex": i + 1 === step }
                )}
              >
                <div className="step__content">
                  <p className="step-number">Step {i + 1}</p>
                  <h3 className="mb-3">{_stepContent.acfPartials.pHeading}</h3>
                  <div
                    className="mr-lg-5"
                    dangerouslySetInnerHTML={{
                      __html: _stepContent.acfPartials.pContent,
                    }}
                  />
                </div>
                <div className="mt-4 mt-lg-0 mb-lg-5">
                  <button
                    className={cx("button btn-step__back rounded-circle")}
                    disabled={step <= 1}
                    onClick={() => setStep(step - 1)}
                  >
                    <MenuArrowIcon className="align-middle text-center" />
                  </button>
                  <button
                    className={cx(
                      "button btn-step__continue rounded-circle ml-4"
                    )}
                    disabled={step >= 3}
                    onClick={() => setStep(step + 1)}
                  >
                    <MenuArrowIcon className="align-middle text-center" />
                  </button>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowToBuyStocks;
